import React from 'react';
import styled from 'styled-components';
import { siteConfig } from '../../config/site';

const Section = styled.section` padding: 5rem 1rem; background: var(--background-light); `;
const Inner = styled.div` max-width: 1200px; margin: 0 auto; `;

const Head = styled.div`
  text-align: center;
  max-width: 720px;
  margin: 0 auto 3rem;
  .tag {
    display: inline-block;
    padding: 0.35rem 0.9rem; border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(0,153,0,0.08); color: var(--primary-color);
    font-size: 0.75rem; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
    margin-bottom: 1rem;
  }
  h2 { font-size: clamp(1.75rem, 3.2vw, 2.5rem); margin: 0 0 0.75rem; color: var(--text-color); span { color: var(--primary-color); } }
  p { color: var(--text-secondary); line-height: 1.7; margin: 0; }
`;

const Track = styled.ol`
  list-style: none;
  padding: 0; margin: 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  position: relative;

  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 500px) { grid-template-columns: 1fr; }
`;

const Step = styled.li`
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(0, 153, 0, 0.15);
  border-radius: var(--border-radius);
  padding: 1.5rem 1.25rem;
  position: relative;

  .num {
    position: absolute;
    top: -14px; left: 1rem;
    background: var(--primary-color);
    color: var(--text-color);
    width: 28px; height: 28px;
    border-radius: 50%;
    display: inline-flex; align-items: center; justify-content: center;
    font-weight: 800; font-size: 0.85rem;
  }
  h3 { margin: 0.75rem 0 0.4rem; color: var(--text-color); font-size: 1.05rem; }
  p { color: var(--text-secondary); margin: 0; line-height: 1.55; font-size: 0.9rem; }
`;

const CheckoutSteps: React.FC = () => (
  <Section id="how-it-works">
    <Inner>
      <Head>
        <div className="tag">How ordering works</div>
        <h2>From cart to first flash in <span>under 5 minutes</span></h2>
        <p>Straightforward checkout, instant delivery, and 24/7 activation support on WhatsApp.</p>
      </Head>
      <Track>
        <Step><span className="num">1</span><h3>Pick a plan</h3><p>Choose the license that matches your daily flash volume. All plans include TRC-20, ERC-20 and BEP-20.</p></Step>
        <Step><span className="num">2</span><h3>Pay with BTC or USDT</h3><p>Scan the QR or copy the wallet address on the checkout page. On-chain confirmation is enough.</p></Step>
        <Step><span className="num">3</span><h3>Get your license by email</h3><p>License key + download link arrive within minutes. Message us on WhatsApp for the fast track.</p></Step>
        <Step><span className="num">4</span><h3>Install &amp; start flashing</h3><p>Install on Windows / macOS / Android, paste the key, pick a network — the flash USDT appears on supported wallets.</p></Step>
      </Track>
      <p style={{ textAlign: 'center', marginTop: '2rem', color: 'var(--text-secondary)' }}>
        Need help? <a href={`https://wa.me/${siteConfig.contact.whatsapp}`} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)' }}>Message us on WhatsApp</a>
      </p>
    </Inner>
  </Section>
);

export default CheckoutSteps;
